import { render, staticRenderFns } from "./PurchaseStockPage.vue?vue&type=template&id=06380c84&"
import script from "./PurchaseStockPage.vue?vue&type=script&lang=js&"
export * from "./PurchaseStockPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports